import { Component, OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef, Inject, ElementRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, RouterModule, Router } from '@angular/router';
import { FormArray, FormControl, AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { LoaderService } from 'app/main/apps/loader/loader.service';
import { first } from 'rxjs/operators';
import { AlertService, AuthenticationService, StorageService } from 'app/main/apps/_services';
import { fuseAnimations } from '@fuse/animations';
@Component({
    selector: 'invite-associate',
    templateUrl: './invite-associate.component.html',
    styleUrls: ['./invite-associate.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: false
})
export class InviteAssociateComponent implements OnInit {
    direction = 'row';
    currentUser: any;
    company_id: any;
    unit_id: any;
    project_id: any;
    project_name: any;
    submitted = false;
    InviteAssociateFormGroup: FormGroup;
    mileStoneGet: any;
    preceeding_activity: any;
    activityGet: any;
    proCompanyUser: any;
    exmemberUser: any;

    activitySrNo: any;
    preActivity_sr_no: any;
    proAllDetails: any;
    projectDetails: any;
    preceeding_activityGet: any;
    dataSourceProActivity: MatTableDataSource<any>;
    constructor(
        public dialogRef: MatDialogRef<InviteAssociateComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _formBuilder: FormBuilder,
        private alertService: AlertService,
        private loaderService: LoaderService,
        private route: ActivatedRoute,
        private router: Router,
        public dialog: MatDialog,
        private cd: ChangeDetectorRef,
        private storageService: StorageService,
        private authenticationService: AuthenticationService
    ) {
        this.currentUser = this.storageService.getItem('SignIn');
    }
    ngOnInit(): void {
        // email: ['', [Validators.required, Validators.email, Validators.pattern(/^([\w.-]+)@(\[(\d{1,3}\.){3}|(?!hotmail|gmail|googlemail|yahoo|gmx|ymail|outlook|bluewin|protonmail|t\-online|web\.|online\.|aol\.|live\.)(([a-zA-Z\d-]+\.)+))([a-zA-Z]{2,4}|\d{1,3})(\]?)$/)]]
        this.InviteAssociateFormGroup = this._formBuilder.group({
            //email: ['', Validators.required]
            //this.generalInfo = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            // });
        });
    }

    InviteAssociate() {
        const reqData = {
            "InviteBuyerAssociate": {
                "LoginSessionKey": this.currentUser.LoginSessionKey, "Value": this.InviteAssociateFormGroup.value.email, "Type": "Email",
                "BothOption": [10, 11].indexOf(this.currentUser.UserDetails.UserTypeID) != -1 ? 'Seller' : 'Buyer'
            }
        };
        this.authenticationService.InviteBuyerAssociate(reqData).subscribe((res: any) => {
            if (res.ResponseCode == 200) {
                this.alertService.success(res.Message, true, 5000);
            } else {
                this.alertService.error(res.Message);
            }
        });
    }

    dialogClose(): void {
        this.dialogRef.close();
    }

}
export const confirmPasswordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (!control.parent || !control) {
        return null;
    }
    const new_password = control.parent.get('new_password');
    const confirm_password = control.parent.get('confirm_password');
    if (!new_password || !confirm_password) {
        return null;
    }
    if (confirm_password.value === '') {
        return null;
    }
    if (new_password.value === confirm_password.value) {
        return null;
    }
    return { 'passwordsNotMatching': true };
};